





































































































































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { CatalogItem, Renglon } from '@/models/StateAlmacenes';

export default Vue.extend({
	name: 'detalleAlmacenes',
	data() {
		return {
			dialogVisible: false,
			dialogConfirmar: false,
			selectedId: '' as string,
			cantidadDialog: 1,
			//Buscador
			searchText: '',
			searchDebounceTimer: 0 as any,
			MIN_CHARS: 3,
			lastQuery: '' as string,
			// Cantidades para el dropdown
			cantidades: Array.from({ length: 50 }, (_, i) => i + 1),
			isEditing: false as boolean,
			editingId: null as string | number | null,
		};
	},
	computed: {
		isIOS() {
			const ua = window.navigator.userAgent;
			const isIOSDevice = /iP(hone|od|ad)/.test(ua);
			const isTouchMac = /Mac/.test(ua) && navigator.maxTouchPoints > 0;
			return isIOSDevice || isTouchMac;
		},
		numero(): number {
			return Number(this.$route.params.id);
		},
		...mapGetters('almacenes', ['catalogResults', 'isCatalogLoading', 'orderLines', 'visibleOrderLines', 'isLinesLoading', 'linesError']),
		catalogOptions(): CatalogItem[] {
			return (this as any).catalogResults;
		},
		renglones(): Renglon[] {
			return (this as any).visibleOrderLines(this.numero);
		},
		errorMsg(): string | null {
			return (this as any).linesError(this.numero);
		},
		isCatalogLoading(): boolean {
			return (this as any).catalogLoading;
		},
	},
	created() {
		(this as any).fetchRenglonesPorPedido(this.numero);
	},
	methods: {
		reopenDropdown() {
			// Abre el menú sí o sí
			this.openSelectDropdown();

			// Si no hay opciones cargadas pero hay texto suficiente, re-busca
			const q = (this.searchText || '').trim().replace(/\s+/g, ' ');
			if ((!this.catalogOptions || this.catalogOptions.length === 0) && q.length >= this.MIN_CHARS) {
				clearTimeout(this.searchDebounceTimer);
				this.lastQuery = q;
				this.searchDebounceTimer = setTimeout(() => {
					(this as any).buscarCatalogo({ descri: q, codemp: 1, iduser: 8888 });
					this.$nextTick(() => this.openSelectDropdown());
				}, 50); // pequeño delay para no “pelearse” con el popper
			}
		},
		openSelectDropdown() {
			this.$nextTick(() => {
				const sel = this.$refs.productSelect as any;
				// abre el menú si está cerrado
				if (sel && typeof sel.toggleMenu === 'function') if (!sel.visible) sel.toggleMenu();
			});
		},
		onExternalInput() {
			const q = (this.searchText || '').trim().replace(/\s+/g, ' ');
			clearTimeout(this.searchDebounceTimer);

			// mantener el dropdown abierto mientras escribe
			this.openSelectDropdown();

			if (q.length < this.MIN_CHARS) {
				this.lastQuery = '';
				(this as any).$store.commit('almacenes/SET_CATALOG_RESULTS', []);
				return;
			}
			if (q === this.lastQuery) return;
			this.lastQuery = q;

			this.searchDebounceTimer = setTimeout(() => {
				(this as any).buscarCatalogo({ descri: q, codemp: 1, iduser: 8888 });
				// aseguro dropdown visible cuando llegan resultados
				this.$nextTick(() => this.openSelectDropdown());
			}, 300);
		},
		onPickProducto(val: string | number) {
			// opcional: reflejar la etiqueta elegida en el input
			const item = this.catalogOptions.find(o => o.id === val);
			if (item) this.searchText = this.formatOption(item);
		},
		onDialogOpened() {
			setTimeout(() => {
				this.$nextTick(() => this.focusProductSelect());
			}, 50);
		},
		onDialogClose() {
			// cerrar el dropdown si quedó abierto
			const sel = this.$refs.productSelect as any;
			if (sel && sel.visible && typeof sel.toggleMenu === 'function') sel.toggleMenu();

			// cancelar timers
			clearTimeout(this.searchDebounceTimer);
			this.searchDebounceTimer = 0;

			// limpiar UI local
			this.searchText = '';
			this.selectedId = '';
			this.cantidadDialog = 1;
			this.lastQuery = '';
			this.isEditing = false;
			this.editingId = null;

			// limpiar resultados del store
			(this as any).$store.commit('almacenes/SET_CATALOG_RESULTS', []);
		},
		focusProductSelect() {
			this.$nextTick(() => {
				const sel = this.$refs.productSelect as any; // 👈 casteo rápido
				if (sel && typeof sel.focus === 'function') sel.focus();
			});
		},
		...mapActions('almacenes', ['buscarCatalogo', 'addProductoLocal', 'fetchRenglonesPorPedido', 'replaceProductoLocal']),
		// Abre diálogo para agregar producto
		openAdd() {
			this.isEditing = false;
			this.editingId = null;
			this.selectedId = '';
			this.cantidadDialog = 1;
			this.dialogVisible = true;
		},
		// Abre diálogo para editar producto
		openEdit(id: string | number) {
			this.isEditing = true;
			this.editingId = id;
			const all: Renglon[] = (this as any).orderLines(this.numero);
			const line = all.find(l => l.id === id);
			this.cantidadDialog = line ? Number(line.cantidad) : 1;
			this.selectedId = '';
			this.dialogVisible = true;
		},
		// lo que ve el usuario en el dropdown
		formatOption(opt: CatalogItem) {
			const precio = opt.precio ? ` $${opt.precio}` : '';
			return `${opt.nombre}${precio}`;
		},
		confirmAgregar() {
			const item: CatalogItem | undefined = this.catalogOptions.find(o => o.id === this.selectedId);
			if (!item) return this.$message.warning('Elegí un producto');
			if (this.isEditing) {
				// Reemplaza producto en la línea manteniendo cantidad actual
				if (!this.editingId && this.editingId !== 0) return this.$message.error('Línea no encontrada');
				(this as any).replaceProductoLocal({ numero: this.numero, id: this.editingId, item });
				this.$message.success('Producto actualizado');
			} else {
				// Agregar nuevo respetando la cantidad elegida (default 1)
				if (!this.cantidadDialog || this.cantidadDialog < 1) return this.$message.warning('Cantidad inválida');
				(this as any).addProductoLocal({ numero: this.numero, item, cantidad: this.cantidadDialog });
				this.$message.success('Producto agregado');
			}
			this.selectedId = '';
			this.cantidadDialog = 1;
			this.isEditing = false;
			this.editingId = null;
			this.dialogVisible = false;
		},
		goToBack() {
			this.$router.push({ name: 'Almacenes' });
		},
		eliminarProducto(id: number | string) {
			this.$store.commit('almacenes/SET_LINE_CANTIDAD', {
				numero: this.numero,
				id,
				cantidad: 0,
			});
			// al ser cantidad=0, el getter visible filtra y desaparece de inmediato
			this.$message.success('Producto eliminado');
		},
		// Confirmar pedido (putPedido)
		async onConfirmar() {
			try {
				await this.$store.dispatch('almacenes/confirmarPedido', {
					numero: this.numero,
					codemp: 1,
					codcom: this.numero,
					codtal: this.numero,
					usrid: '8888',
				});

				this.$message.success('Pedido confirmado');
				this.$router.push({ name: 'Almacenes' });
			} catch (e) {
				this.$message.error('No se pudo completar la confirmación.');
			}
		},
	},
	watch: {
		dialogVisible(val: boolean) {
			if (!val) this.onDialogClose();
		},
	},
});
